import * as React from 'react';
const TagGroup = (props) => {
    const { Tag } = props.components;
    const BEM = () => {
        const classArray = ['tag-group'];
        const { align = 'vertical' } = props;
        classArray.push(`tag-group--align-${align}`);
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const tagBEM = (className) => {
        const classArray = ['tag-group__tag'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() }, props.tags.map((tag, index) => (React.createElement(Tag, Object.assign({}, tag, { key: index, size: props.size, className: tagBEM(tag.className) }))))));
};
export default TagGroup;
